real.events.on('widget:prompt:preview-generation:completed', function (notification) {
    const sourceWidget = $('.widget[data-widget-type="' + notification.object.source_widget.type + '"][data-widget-id="' + notification.object.source_widget.id + '"]');
    if (sourceWidget.length === 0) {
        return;
    }

    howspace.aiGen.clearPromptTimeout(sourceWidget)

    const previewModal = $('dialog[data-source-widget-type="' + notification.object.source_widget.type + '"][data-source-widget-id="' + notification.object.source_widget.id + '"]');
    const previewWrapper = previewModal.find('.widget-preview-wrapper');
    previewWrapper.html(notification.object.html);

    // Store control data in the modal data attributes.
    previewModal.dataAndAttr('widget-type', notification.object.requested_widget_type);
    previewModal.dataAndAttr('target-page-id', notification.object.target_location.page_id);
    previewModal.dataAndAttr('target-column-id', notification.object.target_location.column_id);

    // If there is any widget in the target location, set the before widget id to the first widget in the target column,
    // so that the new widget will be added before it. Otherwise, it will be added at the end of the column.
    const nextWidget = sourceWidget.nextAll('.widget').first();
    if (nextWidget.length > 0) {
        previewModal.dataAndAttr('target-before-widget-id', nextWidget.data('widget-id'));
    }

    const initPollPreviewComponents = (previewWrapper) => {
        previewWrapper.find('.add-option-btn').on('click', () => {
            const sortableList = previewWrapper.find('.howspace-sortable-list');
            const option = howspace.components.sortableList.addItem(sortableList);
            const index = (sortableList.find('.option').length - 1) % howspace.components.colorPicker.getPalette().length;
            const color = howspace.components.colorPicker.getPalette()[index];
            howspace.components.colorPicker.setColor(option.find('.howspace-color-picker'), color);
        });

        previewWrapper.find('.delete-option-btn').on('click', e => {
            const btn = $(e.target);
            const option = btn.closest('.option');
            option.velocity('slideUp', 'fast', () => {
                option.remove();
            });
        });
    };

    const initPulsePreviewComponents = (previewWrapper) => {
        // Scale type radio buttons.
        previewWrapper.find('input[data-name="scale_type"]').on('change', e => {
            if ($(e.currentTarget).val() === howspace.widgets.pulse.SCALE_TYPE_NPS) {
                // disable adding questions
                previewWrapper.find('.add-question-btn').prop('disabled', true);

                // add default eNPS question if missing
                if (previewWrapper.find('.question-sortable-list .question').length === 0) {
                    const question = howspace.components.sortableList.addItem(previewWrapper.find('.question-sortable-list'));
                    question.find('.title').val(howspace.translate('pulse_question_title_enps'));
                    question.find('.is-enabled').addClass('disabled').find('input').prop('disabled', true);
                    question.find('.btn').prop('disabled', true);
                }

            } else {
                // enable adding questions
                previewWrapper.find('.add-question-btn').prop('disabled', false);

                // enable editing questions
                const questions = previewWrapper.find('.question-sortable-list .question');
                questions.find('.is-enabled').removeClass('disabled').find('input').prop('disabled', false);
                questions.find('.btn').prop('disabled', false);
            }
        });

        // Add a question button.
        previewWrapper.find('.add-question-btn').on('click', e => {
            howspace.components.sortableList.addItem(previewWrapper.find('.question-sortable-list'));
        });

        // Add an answering round button.
        previewWrapper.find('.add-answering-round-btn').on('click', _e => {
            const sortableList = previewWrapper.find('.answering-round-sortable-list');
            howspace.components.sortableList.addItem(sortableList,
                { number: sortableList.find('.answering-round').length + 1 });
        });

        // Add the first answering round.
        if (previewWrapper.find('.answering-rounds .answering-round').length === 0) {
            previewWrapper.find('.add-answering-round-btn').click();
        }

        // Scale type input.
        previewWrapper.find('.howspace-range-input-left').on('input', updateLegend);
        previewWrapper.find('.howspace-range-input-right').on('input', updateLegend);
    };

    const initPriorityPreviewComponents = (previewWrapper) => {
        previewWrapper.find('.add-option-btn').on('click', () => {
            const sortableList = previewWrapper.find('.howspace-sortable-list');
            howspace.components.sortableList.addItem(sortableList);
        });

        previewWrapper.find('.delete-option-btn').on('click', e => {
            const btn = $(e.target);
            const option = btn.closest('.option');
            option.velocity('slideUp', 'fast', () => {
                option.remove();
            });
        });
    }

    const initAllocatePreviewComponents = (previewWrapper) => {
        previewWrapper.find('.add-option-btn').on('click', () => {
            const sortableList = previewWrapper.find('.howspace-sortable-list');
            howspace.components.sortableList.addItem(sortableList);
        });

        previewWrapper.find('.delete-option-btn').on('click', e => {
            const btn = $(e.target);
            const option = btn.closest('.option');
            option.velocity('slideUp', 'fast', () => {
                option.remove();
            });
        });
    }

    const updateLegend = (e) => {
        const range = $(e.currentTarget).parent();
        const widget = range.closest('.widget');
        const scaleType = range.data('scale-type');
        const leftValue = parseInt(range.find('.howspace-range-input-left').val());
        const rightValue = parseInt(range.find('.howspace-range-input-right').val());

        // hide all legend items
        widget.find('.legend-item[data-scale-type="' + scaleType + '"]').addClass('d-none');

        // show legend items for the current range
        for (let i = leftValue; i <= rightValue; i++) {
            widget.find('.legend-item[data-scale-type="' + scaleType + '"][data-index="' + i + '"]').removeClass('d-none');
        }
    };
    // TODO: These init functions are a copy-paste from widget initEdit. Refactor to avoid duplication.

    // General components initialization.
    howspace.components.init(previewWrapper);

    switch (notification.object.requested_widget_type) {
        case 'poll':
            // Poll specific components initialization.
            initPollPreviewComponents(previewWrapper);
            break;
        case 'pulse':
            // Pulse specific components initialization.
            initPulsePreviewComponents(previewWrapper);
            break;
        case 'priority':
            // Priority specific components initialization.
            initPriorityPreviewComponents(previewWrapper);
            break;
        case 'allocate':
            initAllocatePreviewComponents(previewWrapper);
            break;
        default:
            real.notification.show(notification.object.requested_widget_type + ' preview is not supported yet.', 'danger');
            break;
    }

    real.button.reset(sourceWidget.find('.generate-poll-btn'), sourceWidget.find('.prompt-input-wrapper'));
    real.button.reset(sourceWidget.find('.generate-pulse-btn'), sourceWidget.find('.prompt-input-wrapper'));
    real.button.reset(sourceWidget.find('.generate-priority-btn'), sourceWidget.find('.prompt-input-wrapper'));
    real.button.reset(sourceWidget.find('.generate-allocate-btn'), sourceWidget.find('.prompt-input-wrapper'));
    previewModal.find('.save-btn').prop('disabled', false).removeClass('disabled');
});
